import React, { useEffect, useState } from 'react';
import BankDepositField from './BankDepositField';


const AddBankDeposit = () => {
     return (
        <div className='mx-auto p-2 mt-8'>
            <h1 className='text-md text-center bg-primary p-3 text-white rounded-xl'>Add A Bank Deposit</h1>
            <BankDepositField></BankDepositField>
        </div>
    );
};

export default AddBankDeposit;